export const EmptyRecipeContainer = () => (
    <div className="empty-recipe-container">
        <p>No recipes found</p>
    </div>
)